import { dataMap, fetcher, getInventoryRecord, hasInStock } from '@/core/data/Content/_Inventory';
import { getStoreLocale } from '@/data/Content/StoreLocale-Server';
import { getLocalization } from '@/data/Localization';
import { getSettings } from '@/data/Settings';
import { DATA_KEY_INVENTORY } from '@/data/constants/dataKey';
import { Cache } from '@/data/types/Cache';
import { InventoryResponse } from '@/data/types/ProductAvailabilityData';
import { constructRequestParamsWithPreviewToken } from '@/data/utils/constructRequestParams';
import { getServerSideCommon } from '@/data/utils/getServerSideCommon';
import { shrink } from '@/data/utils/keyUtil';
import { GetServerSidePropsContext } from 'next';
import { unstable_serialize as unstableSerialize } from 'swr';

// Override getInventory, to use productId instead of partNumber
export const getInventory = async (
	cache: Cache,
	productId: string,
	context: GetServerSidePropsContext
): Promise<
	{
		key: string;
		value: InventoryResponse;
	}[]
> => {
	const settings = await getSettings(cache, context);
	const { localeName: locale } = await getStoreLocale({ cache, context });
	const routes = await getLocalization(cache, locale, 'Routes');
	const { storeId, langId } = getServerSideCommon(settings, context);
	const props = { storeId, productId, langId };
	const key = unstableSerialize([shrink(props), DATA_KEY_INVENTORY]);
	const params = constructRequestParamsWithPreviewToken({ context, settings, routes });
	const value = cache.get(key) || fetcher(false, context)(storeId, productId, {}, params);
	cache.set(key, value);
	return await value;
};

// export the OOB functions
export { dataMap, fetcher, getInventoryRecord, hasInStock };
